module.exports = __webpack_public_path__ + "img/1523473782.115d26ec.jpg";